import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import { chatApiStore, chatStore } from "@/hooks";
import {
  IconButton,
  ListItem,
  Typography,
  FlexBox,
  TextButton,
} from "@/components/common";

/**
 * Displays a list of chats for the current project.
 */
const __default__ = {
  name: "ProjectChatList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    "model-value": "",
    persistent: "",
    bordered: "",
    breakpoint: 0,
    width: 260,
    class: "bg-background"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        "full-width": "",
        justify: "between",
        align: "center",
        t: "1",
        class: "q-pa-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Typography), {
            variant: "subtitle",
            value: "Chats"
          }),
          _createVNode(_unref(TextButton), {
            text: "",
            disabled: _unref(chatApiStore).loading,
            label: "Create",
            icon: "add",
            "data-cy": "button-add-attribute",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(chatStore).addChat()))
          }, null, 8, ["disabled"])
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatStore).chats, (chat) => {
        return (_openBlock(), _createBlock(_unref(ListItem), {
          key: chat.id,
          title: chat.title,
          clickable: "",
          focused: _unref(chatStore).currentChat?.id === chat.id,
          "action-cols": 1,
          onClick: ($event: any) => (_unref(chatApiStore).handleLoadProjectChatMessages(chat))
        }, {
          actions: _withCtx(() => [
            _createVNode(_unref(IconButton), {
              small: "",
              icon: "delete",
              tooltip: "Delete chat",
              onClick: ($event: any) => (_unref(chatApiStore).handleDeleteProjectChat(chat.id))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["title", "focused", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})